module.exports = __webpack_public_path__ + "img/image-1.bf0eb6f7.jpg";